import common from "./common";
import { SURL } from "../../../sbase";

const fileMixin = {
  props: {
    field: {},
    fieldValue: "",
    fieldResult: {},
    checkFlag: false
  },
  data() {
    return {
      fieldObj: {},
      defaultFileList: []
    };
  },
  watch: {
    checkFlag() {
      //校验
      this.fieldObj.dirty = true;
      //输出结果到父级
      common.updateData(this, this.fieldObj);
    }
  },
  created() {
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = ((window.$sk && window.$sk.$t) || function(k){return '请上传';})('field.please_upload');
    }
    this.fieldObj = new window.$sk.File(this.field);
    // 不是读写权限禁用
    this.fieldObj.disabled = this.field.permissionType && this.field.permissionType != 'write';
    //回填数据
    if (!this.fieldValue) {
      return;
    }
    this.fieldObj.setValue({
      fileName: this.fieldValue.ornName || this.fieldValue.fileName,
      mapId: this.fieldValue.mappingId || this.fieldValue.mapId,
      mappingId: this.fieldValue.mappingId || this.fieldValue.mapId,
      newPath:
        this.fieldValue.pathUrl ||
        SURL.template.api.ungateway.contentUrl +
          "?mappingId=" +
          this.fieldValue.mapId
    });
  },
  methods: {
    changeFile(e) {
      this.fieldObj.upload(e.target.files[0]);
      this.$emit("change",{
        displayType:this.fieldObj.displayType,
        value: e.target.files[0],
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy
      });
    },

    clearFile() {
      this.fieldObj.setValue(null);
      this.$emit("change",{
        displayType:this.fieldObj.displayType,
        value: "",
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy
      });
    }
  }
};
export default fileMixin;
